import { API_URL } from '@constants'
import axiosReadInstance from '../../request/axiosReadInstance'
import ReactMarkdown from 'react-markdown'
import { cmsRehypePlugins } from '../../security/cmsMarkdown'
import { useCallback, useEffect, useState } from 'react'
import { usePageLoading } from '../../context/PageLoadingContext'

interface IVision {
    content: string
    title: string
}

export const Vision = () => {
    const [vision, setVision] = useState<IVision>()
    const markdown = `${vision?.content}`
    const { incrementLoadingRequestCount, decrementLoadingRequestCount } =
        usePageLoading()

    const fetchData = useCallback(async () => {
        incrementLoadingRequestCount()
        await axiosReadInstance
            .get(`${API_URL}/api/vision?populate=deep`)
            .then((response) => {
                setVision(response.data.data.attributes)
            })
            .finally(() => {
                decrementLoadingRequestCount()
            })
    }, [incrementLoadingRequestCount, decrementLoadingRequestCount])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    return (
        <>
            <section className="section-style">
                <div className="lg:pt-6 lg:pb-16 md:px-[8rem]">
                    <h2 className="h1-title">{vision?.title}</h2>
                    <ReactMarkdown
                        className="h1-subtext"
                        rehypePlugins={cmsRehypePlugins}
                    >
                        {markdown || ''}
                    </ReactMarkdown>
                </div>
            </section>
        </>
    )
}
